import { Tooltip, Switch } from "antd";

import { RVFormItem, RVIcon, RVIconSizeOptions } from "@regal-voice/ui";
import { Row } from "Components/shared/Flexbox";

import styles from "./LastEventFormItem.module.scss";

export function LastEventFormItem({ name, hidden }: { name: number; hidden?: boolean }): JSX.Element {
    return (
        <Row
            className={styles.lastEventOnly}
            justifyContent="space-between"
            alignItems="center"
            gap={2}
            style={{ visibility: hidden ? "hidden" : "visible", height: hidden ? "0" : "unset" }}
        >
            <Row alignItems="center">
                <label htmlFor="lastEventOnly">
                    <strong>Last Event Only</strong>
                </label>
                <Tooltip
                    placement="top"
                    title={
                        <div className={styles.infoSpan}>
                            If contact has more than one instance of this event, only reference the last instance (not
                            all) to satisfy condition
                        </div>
                    }
                >
                    <RVIcon className={styles.smallIcon} size={RVIconSizeOptions.SMALL} icon="info-circle" />
                </Tooltip>
            </Row>
            <RVFormItem
                name={[name, "lastEventOnly"]}
                valuePropName="checked"
                initialValue={false}
                noStyle
                hidden={hidden}
            >
                <Switch />
            </RVFormItem>
        </Row>
    );
}
